import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = ["onClick"]

import Vue, {
  onMounted,
  ref,
  watch,
  defineAsyncComponent,
  onBeforeUnmount,
  computed,
} from "vue";
import {
  admDateList,
  configAdmList,
  admDateListAdUnit,
  h5AdmDateList,
  adsDetailList,
  allH5AdmDateList,
} from "@/api/api";
import XDialog from "@/components/XDialog.vue";

import { useStore } from "vuex";
import dayjs, { Dayjs } from "dayjs";

interface ConfigItem {
  dbName: string;
  appName: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAdsList',
  props: {
    appData: {},
    dateTime: {},
    isRefresh: { type: Boolean },
    dbName: {}
  },
  setup(__props: any) {

const XATable = defineAsyncComponent(() => import("@/components/XATable.vue"));
const store = useStore();
const props = __props;
const currentAppId = ref("");
const rightAppIdVal = ref<any[]>([]);
var appIdList: any[] = [];
const maxTagCount = ref(1);
const checkedValue = ref(true);
const configList = ref<ConfigItem[]>([]);
const dateValue = ref("");
const pageNo = ref(1);
const activeKey = ref(-1);
const detailVisible = ref(false);
const detailLoading = ref(false);
const adsTitle = ref("详情");
const curDetailRow = ref<any>({});

const columns = ref([
  { title: "Date", key: "day", dataIndex: "day" },
  //   { title: "ID", key: "id", dataIndex: "id" },
  //   { title: "Remark", key: "scene", dataIndex: "scene" },
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  { title: "*Revenue", key: "income", dataIndex: "income" },
  { title: "Action", key: "action", dataIndex: "action" },
]);
const detailColumns = ref([
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  { title: "*Revenue", key: "income", dataIndex: "income" },
  { title: "URL", key: "url", dataIndex: "url" },
]);
const tableData = ref([]);
const detailTableData = ref([]);
const loading = ref(false);
let timerInval = ref();
var BackOrderIds: any[] = [];

const getRequestData = () => {
  // 添加安全检查
  if (
    !dateValue.value ||
    !Array.isArray(dateValue.value) ||
    dateValue.value.length < 2
  ) {
    console.warn("dateValue is not properly set");
    return;
  }

  loading.value = true;
  const params: any = {
    beginTime: dayjs(dateValue.value[0]).format("YYYY-MM-DD"),
    endTime: dayjs(dateValue.value[1]).format("YYYY-MM-DD"),
  };
  if (activeKey.value !== -1) {
    params.dbName = activeKey.value;
  }
  allH5AdmDateList(params)
    .then((res) => {
      loading.value = false;
      //console.log(res.data, "=================");
      tableData.value = res.data || [];
    })
    .catch((error) => {
      loading.value = false;
      console.error("Failed to fetch data:", error);
    });
};
// 监听 Vuex 的 refreshNeeded 状态
const refreshNeeded = computed(() => store.state.refundRefreshNeeded);

// 监控 refreshNeeded 的变化
watch(refreshNeeded, (newValue) => {
  if (newValue) {
    // 执行页面刷新操作
    getRequestData();
    // 重置刷新状态
    store.dispatch("resetRefundRefresh");
  }
});

watch(
  () => props.isRefresh,
  (cur, old) => {
    getRequestData();
  }
);

watch(
  () => props.dateTime,
  (cur, old) => {
    //console.log(cur);
    dateValue.value = cur;
    getRequestData();
  },
  {
    immediate: true,
  }
);

const tabClick = (tabIndex: any) => {
  //console.log(tabIndex);
  if (tabIndex === -1) {
    currentAppId.value = "";
    activeKey.value = -1;
  } else {
    currentAppId.value = tabIndex;
    activeKey.value = tabIndex;
  }
  getRequestData();
};
const pageChange = (page: any) => {
  pageNo.value = page;
  getRequestData();
};
const getConfigList = () => {
  configAdmList({}).then((res) => {
    configList.value = res.data;
  });
};
const confirmDetail = (row: any) => {
  //console.log(row);
  curDetailRow.value = row;
  adsTitle.value = "详情" + "(" + row.day + ")";
  detailVisible.value = true;
  detailLoading.value = true;
  var beginTime = row.date;
  var endTime = row.date;
  if (row.date === "汇总") {
    beginTime = dayjs(dateValue.value[0]).format("YYYY-MM-DD");
    endTime = dayjs(dateValue.value[1]).format("YYYY-MM-DD");
  }
  var params: any = {
    beginTime: row.day,
    endTime: row.day,
  };
  if (activeKey.value !== -1) {
    params.dbName = activeKey.value;
  }

  adsDetailList(params).then((res) => {
    detailLoading.value = false;
    detailTableData.value = res.data;
  });
};
onMounted(() => {
  checkedValue.value = store.state.refundCheckedValue;
  dateValue.value = props.dateTime;
  getConfigList();
  getRequestData();
});
const toFixedDown = (num: any, digits: any) => {
  const factor = Math.pow(10, digits);
  return Math.floor(num * factor) / factor;
};

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_tabs, {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
      onTabClick: tabClick
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: -1,
          tab: "全部"
        })),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.dbName,
            tab: item.appName,
            disabled: loading.value
          }, null, 8, ["tab", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(_unref(XATable), {
      columns: columns.value,
      dataSource: tableData.value,
      loading: loading.value
    }, {
      pageView: _withCtx(({ record }) => []),
      income: _withCtx(({ record }) => [
        _createTextVNode(" $ " + _toDisplayString(record.income), 1)
      ]),
      action: _withCtx(({ record }) => [
        (record.day !== '汇总')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: ($event: any) => (confirmDetail(record))
            }, "详情", 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource", "loading"]),
    _createVNode(XDialog, {
      visible: detailVisible.value,
      title: adsTitle.value,
      xWidth: "100%",
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (detailVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(XATable), {
          columns: detailColumns.value,
          dataSource: detailTableData.value,
          loading: detailLoading.value
        }, {
          income: _withCtx(({ record }) => [
            _createTextVNode(" $ " + _toDisplayString(record.income), 1)
          ]),
          _: 1
        }, 8, ["columns", "dataSource", "loading"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})